import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";


//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addParticipantsInvites, editParticipantsInvites } from "store/actions";
import { withTranslation } from "react-i18next";


const AddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchParticipantsInvitesListData } = props
    const [participantsInvitesData, setParticipantsInvitesData] = useState();
    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.ParticipantsInvites.loading,
        error: state.ParticipantsInvites.error,
        success: state.ParticipantsInvites.success,
        editLoading:state?.ParticipantsInvites?.editLoading
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setParticipantsInvitesData(itemData)
    }, [itemData])
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            invitation_title: participantsInvitesData?.invitation_title || '',
            is_active: participantsInvitesData?.is_active || 'Y'
        },
        validationSchema: Yup.object({
            invitation_title: Yup.string().required(`${props.t("Please Enter Invitation Title")}`),
            is_active: Yup.string().required(`${props.t("Please Enter Question Status")}`),
        }),
        onSubmit: (values, { resetForm, setFieldValue }) => {
            if (isEdit) {
                dispatch(editParticipantsInvites(values, participantsInvitesData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            invitation_title: '',
                            is_active: 'Y'
                        });
                        fetchParticipantsInvitesListData()
                        toggle()

                    } else {
                        toastr.error(res.message)
                        toggle()
                        

                    }
                }));
            } else {
                dispatch(addParticipantsInvites(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            invitation_title: '',
                            is_active: ''
                        });
                        fetchParticipantsInvitesListData()
                        toggle()
                    } else {
                        toastr.error(res.message)
                        toggle()
                        

                    }
                }));
            }

        }
    });



    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        
                    }}>
                    {!!isEdit ? props.t("Edit Participants Invitation") : props.t("Add Participants Invitation")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Participant Invitation")}:</Label>
                            <Input
                                name="invitation_title"
                                className="form-control"
                                placeholder={props.t("Enter Participant Invitation")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.invitation_title || ""}
                                invalid={
                                    validation.touched.invitation_title && validation.errors.invitation_title ? true : false
                                }
                            />
                            {validation.touched.invitation_title && validation.errors.invitation_title ? (
                                <FormFeedback type="invalid">{validation.errors.invitation_title}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y'}
                                    value="Y"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N'}
                                    value="N"
                                    type="radio"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div>

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }
                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


AddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(AddEditModal);

